import { useEffect, useState } from 'react';
import { isDesktopShell } from '../speechInput.js';
import { StarCommandNativeSession } from './StarCommandNative.js';
/** Only the authenticated desktop shell offers this native bridge. Office's WebView is not sufficient. */
export function useStarCommandNative({ desktopWorkspace, enabled, accountKey }) {
    const [value, setValue] = useState();
    const desktop = typeof window !== 'undefined' && isDesktopShell(window);
    useEffect(() => {
        if (!desktopWorkspace || !enabled || !desktop || !accountKey) {
            setValue(undefined);
            return;
        }
        let session, live = true;
        const send = (message) => {
            if (!live)
                throw new Error('Native owner changed');
            window.dispatchEvent(new CustomEvent('gyro:starcommand-request', { detail: message }));
        };
        const bind = (event) => {
            const state = event.detail;
            if (!state || typeof state !== 'object')
                return;
            const { generation, enabled: active } = state;
            if (typeof generation !== 'string' || !/^[0-9a-f]{32}$/.test(generation) || typeof active !== 'boolean')
                return;
            if (session?.generation === generation && active)
                return;
            session?.dispose();
            session = undefined;
            setValue(undefined);
            if (!active)
                return;
            const next = new StarCommandNativeSession(accountKey, generation, send, presentation => {
                if (live && session === next)
                    setValue(presentation);
            });
            session = next;
            setValue(next.presentation);
            void next.refresh();
        };
        const receive = (event) => session?.receive(event.detail);
        window.addEventListener('gyro:attention-session', bind);
        window.addEventListener('gyro:starcommand-message', receive);
        window.dispatchEvent(new CustomEvent('gyro:attention-ready', { detail: {} }));
        const timer = setInterval(() => void session?.refresh(), 30_000);
        return () => {
            clearInterval(timer);
            session?.dispose();
            live = false;
            window.removeEventListener('gyro:attention-session', bind);
            window.removeEventListener('gyro:starcommand-message', receive);
        };
    }, [desktopWorkspace, enabled, desktop, accountKey]);
    return desktopWorkspace && enabled && desktop && value?.accountKey === accountKey ? value : undefined;
}
//# sourceMappingURL=useStarCommandNative.js.map